import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

export const companyList = async (params: any) => {
  let response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_COMPANY_LIST,
    { params }
  );
  let RowData = await response?.data;
  console.log("🚀 ~ companyList ~ RowData:", RowData);

  const formatedData = Array.isArray(response?.data?.data?.data)
    ? response?.data?.data?.data.map((item: any) => ({
        CompanyId: item?.CompanyId,
        CompanyCode: item?.CompanyCode,
        CompanyName: item?.CompanyName,
        OwnerName: item?.OwnerName,
        OwnerEmail: item?.OwnerEmail,

        CompanyDefaultCurrency: item.CompanyDefaultCurrency,
        CompanyAddress1: item.CompanyAddress1,
        CompanyAddress2: item.CompanyAddress2,
        CompanyPhoneNumber: item.CompanyPhoneNumber,
        CompanyContactNumber: item.CompanyContactNumber,
      }))
    : [];
  return { formatedData, RowData };
};

export const getAdminCurrencies = async () => {
  let response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_AdminCurrencies
  );
  //  console.log('response=====>',response?.data.data);
  let rowData = response?.data;
  const formatedData = Array.isArray(response?.data.data)
    ? response?.data.data.map((item: any) => ({
        id: item.CurrencyId,
        label: item.Name,
      }))
    : [];
  return { formatedData, rowData };
};

export const addCompany = async (ReqBody: any) => {
  let respone = await axiosInstance.post(
    API_ENDPOINTS.SETTING.POST_ADD_COMPANY,
    ReqBody
  );
  console.log(respone?.data);
};

export const UpdateCompany = async (ReqBody: any) => {
  let respone = await axiosInstance.put(
    API_ENDPOINTS.SETTING.PUT_UPDATE_COMPANY,
    ReqBody
  );
  console.log(respone.data);
};

export const getCurrency = async () => {
  let respose = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_CURRENCY_LIST
  );
  const rowData = await respose?.data;

  const formateData = Object.entries(rowData?.data || {}).map(
    ([key, value]) => ({
      id: key,
      label: String(value),
    })
  );
  // console.log("🚀 ~ formateData ~ formateData:", formateData)
  // console.log("🚀 ~ getCurrency ~ respose:", rowData?.data);

  return { formateData, rowData };
};
